<template lang="html">
  <div id="user-access-page">

    <section class="form-section-component">
      <b-form @submit="onSubmit">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-8 col-form">
              <h2 class="mb-2 text-center title-s1">Iniciar sesión</h2>

              <!-- <p class="text-center txt-c-3">Regístrate gratis como artista y comienza a revolucionar tu conexión con los fans</p> -->

              <div class="mt-4 box-white">
                <div class="row justify-content-center">
                  <div class="col-lg-9 pb-2 col-input">
                    <h5 class="text-center txt-c-3">Agrega tu datos para iniciar sesión</h5>
                  </div>

                  <div class="col-lg-9 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Correo electrónico">
                      <b-form-input
                        v-model="form.email"
                        type="email"
                        placeholder="tu@email.com"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-lg-9 col-input">
                    <b-form-group class="custom-f-group-1"
                      label="Contraseña">
                      <b-form-input
                        v-model="form.password"
                        type="password"
                        placeholder="Escribe tu contraseña"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-lg-9 col-input">
                    <b-button type="submit" class="btn-s1 bg-1 w-100">Registrarse como Artista</b-button>
                  </div>

                  <div class="col-lg-9 pt-3 col-input">
                    <p class="text-center txt-c-3">¿Olvidaste tu contraseña?<br />
                      <router-link to="/recuperar-contrasena">Recuperar contraseña</router-link></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-form>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {

      }
    }
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();
    },
  }
}
</script>
